export default "__VITE_ASSET__BY_iT8zi__"